import { getTenantFromHash, lightenHex } from "@/utils/getBrandings";
import InforBtn from "@assets/info-circle.svg";
import { AnimatePresence, motion } from "framer-motion";
import React from "react";

interface NotificationBannerProps {
  message: string;
  onDismiss?: () => void;
  isVisible: boolean;
  showDismissButton?: boolean;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  message,
  onDismiss,
  isVisible,
  showDismissButton,
}) => {
  if (!isVisible) return null;

  return (
    <>
      <AnimatePresence>
        <motion.div
          key="employer-match"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -10 }}
          transition={{ duration: 0.4, ease: "easeInOut" }}
        >
          <div
            className="w-full p-[12px] rounded-[8px] flex justify-between items-center"
            style={{
              background: getTenantFromHash()
                ? lightenHex(window.partner.colors.primary, 0.6)
                : "#E1FBFB",
            }}
          >
            <div className="flex space-x-2 items-center">
              <img
                src={InforBtn}
                alt="Information"
                className="inline-block h-5 w-5 mt-0.5"
              />
              <p className="font-normal leading-[127%] text-[16px]">
                {message}
              </p>
            </div>
            {showDismissButton && (
              <div className="flex-shrink-0 ml-4">
                <button
                  type="button"
                  className="inline-flex rounded-md bg-white p-1.5 text-brand hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50 transition-colors duration-200"
                  onClick={onDismiss}
                  aria-label="Dismiss banner"
                >
                  <svg
                    className="h-4 w-4"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clipRule="evenodd"
                    />
                  </svg>
                </button>
              </div>
            )}
          </div>
        </motion.div>
      </AnimatePresence>
    </>
  );
};

export default NotificationBanner;
